module.exports = __webpack_public_path__ + "static/media/arrow-dropdown-icon.b95e5a92.svg";